/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-11 23:18:33
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:16:47
 */

import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { HttpClient } from "@angular/common/http";
import {
  FileTransfer,
  FileTransferObject,
  FileUploadOptions
} from "@ionic-native/file-transfer";
import { Media, MediaObject, MEDIA_STATUS } from "@ionic-native/media";
import { LoadingService } from "./loading.service";
import { File } from "@ionic-native/file";
import { Platform } from "ionic-angular";
import { genUniqName } from "../common/utils";

@Injectable()
export class AudioService {
  recording: boolean = false;
  playing: boolean = false;

  filePath: string;
  fileName: string;
  audio: MediaObject;
  duration: number;

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/storage`;
  // private MAX_FILESIZE = 10 * 1024 * 1024; // 10M

  constructor(
    private loadingService: LoadingService,
    private media: Media,
    private file: File,
    public platform: Platform,
    private transfer: FileTransfer,
    private http: HttpClient
  ) {}

  startRecord() {
    if (this.recording) return;

    if (this.platform.is("ios")) {
      this.fileName = "record" + genUniqName() + ".m4a";
    } else if (this.platform.is("android")) {
      this.fileName = "record" + genUniqName() + ".3gp";
    }

    this.filePath = this.getFilePath(this.fileName);
    this.audio = this.media.create(this.filePath);
    this.audio.startRecord();
    this.recording = true;
  }

  stopRecord(needUpload) {
    if (!this.recording) return;

    this.audio.stopRecord();
    this.recording = false;

    if (needUpload) {
      return this.uploadAudio(this.fileName);
    }
  }

  playCloud(realName) {
    if (this.playing) return;

    this.audio = this.media.create(`${ENV.S3_URL}/audio/${realName}`);
    this.audio.play();
    this.audio.setVolume(1.0);
    this.duration = this.audio.getDuration();
    this.playing = true;

    this.audio.onStatusUpdate.subscribe(res => {
      if (res === MEDIA_STATUS.STOPPED) {
        this.playing = false;
      } else {
        this.playing = true;
      }
    });
  }

  private uploadAudio(fileName) {
    return new Promise((resolve, reject) => {
      const realName = fileName.split(".")[0];
      const filePath = this.getFilePath(fileName);
      this.loadingService.showLoading(true);
      this.uploadVoiceByUrl("3gp", realName, filePath).subscribe(() => {
        this.loadingService.showLoading(false);
        resolve(`${realName}.3gp`);
      });
    });
  }

  private uploadVoiceByUrl(type: string, id: string, fileUrl: any) {
    return this.http
      .get(`${this.url}/signed-audio?fileType=${type}&id=${id}`)
      .switchMap(res => {
        // console.log('res', JSON.stringify(res));
        // this.loadingService.showLoading(false);
        const { url } = res["payload"];
        const fileTransfer: FileTransferObject = this.transfer.create();
        let options: FileUploadOptions = {
          httpMethod: "PUT",
          chunkedMode: false,
          headers: {
            "Content-Type": `audio/x-${type}`
          }
        };
        return fileTransfer.upload(fileUrl, url, options);
      });
  }

  private getFilePath(fileName) {
    if (this.platform.is("ios")) {
      return (
        this.file.documentsDirectory.replace(/file:\/\//g, "") + this.fileName
      );
    } else if (this.platform.is("android")) {
      return (
        this.file.externalDataDirectory.replace(/file:\/\//g, "") +
        this.fileName
      );
    }
  }

  // playAudio(file, idx) {
  //   if (this.platform.is('ios')) {
  //     this.filePath = this.file.documentsDirectory.replace(/file:\/\//g, '') + file;
  //   } else if (this.platform.is('android')) {
  //     this.filePath = this.file.externalDataDirectory.replace(/file:\/\//g, '') + file;
  //   }
  //   this.audio = this.media.create(this.filePath);
  //   this.audio.play();
  //   this.audio.setVolume(0.8);
  // }
  // stopAudio() {
  //   this.audio.stop();
  // }
}



// WEBPACK FOOTER //
// ./src/services/audio.service.ts